import MainPage from './MainPage';
import LoadingPage from './LoadingPage';
import Game from './Game';
import { useGlobalContext } from './context';

//chrome.exe --user-data-dir="C://Chrome dev session" --disable-web-security

const App = () => {
  const { play, loading } = useGlobalContext()
  
  //Return Loading Screen
  if (loading)
    return <LoadingPage></LoadingPage>
  //Return Main Page
  if (!play)
    return <MainPage></MainPage>
  //Return Game Screen
  if (play)
    return <Game></Game>
}

export default App;
